import React, { useState, useEffect, useRef } from "react";

import {
  parseFormControlValue,
  checkEmptyObject,
  generateUUID,
  showDropdownSearch,
  getWindowWidth,
  isSearchMobile,
  matchesSearchText
} from "../../../services/utils";
import MultiSelectModal from "../MultiSelectModal";
import SelectContent from "./SelectContent";
import CheckboxContent from "./CheckboxContent";
import {Icon, Tooltip} from "antd";
import styles from "../InputText/styles.scss";

const MultiSelector = props => {
  const {
    options = [],
    title = "",
    onChange = () => null,
    isRequired = false,
    placeholder = "Odaberite",
    showPlaceholder = false,
    field,
    value,
    tooltip,
    getPopupContainer
  } = props;

  const [visibleOptions, setVisibleOptions] = useState(options);
  const [isShownDropdown, setIsShownDropdown] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);
  const id = useRef(generateUUID());
  const selectRef = useRef();

  useEffect(() => {
    if (
      !showDropdownSearch(options.length) &&
      !isSearchMobile(getWindowWidth())
    ) {
      const selectElement = document.getElementById(id.current);
      // @ts-ignore
      if (selectElement && !selectElement.readOnly) {
        // @ts-ignore
        selectElement.readOnly = true;
      }
    }
  }, [options]);

  const onValueChange = selectedOptions => {
    const value =
      !selectedOptions || selectedOptions.length === 0
        ? { [field]: undefined }
        : parseFormControlValue([field], [selectedOptions.map(Number)]);

    onChange(value);
    setVisibleOptions(props.options);
  };

  const renderStringTitles = selectedOptions => {
    const selectedOptionsNumber = selectedOptions.map(Number);

    const titleOptionsSelected = options
      .filter(item => selectedOptionsNumber.includes(item.value))
      .map(item => item.title);

    if (titleOptionsSelected.length === 0) {
      return null;
    }
   
    return (selectedOptionsNumber.length == 1) ? selectedOptionsNumber.join(", ") : titleOptionsSelected.join(", ");
  };

  const getValue = () =>
    checkEmptyObject(value) && value[field] ? value[field] : [];

  const onSelectFocus = () => {
    if (isSearchMobile(getWindowWidth())) {
      setIsShowModal(true);
    } else {
      setIsShownDropdown(true);
      // @ts-ignore
      selectRef.current && selectRef.current.focus();
    }
  };

  const showModal = () => {
    setIsShowModal(true);
  };

  const closeModal = () => {
    setIsShowModal(false);
    if (selectRef.current) {
      // @ts-ignore
      selectRef.current && selectRef.current.focus();
    }
  };

  const onSelectBlur = () => {
    setIsShownDropdown(false);
    // @ts-ignore
    selectRef.current && selectRef.current.blur();
    setVisibleOptions(props.options);
  };

  const handleFilterChange = value => {
    const { options } = props;
    const filteredOptions = options.filter(o => matchesSearchText(value, o.title));

    setVisibleOptions(filteredOptions);
  };

  const renderSelect = mobile => {
    const selectValue = isShownDropdown 
    ? getValue().map(String)
     : renderStringTitles(getValue());
    
    return (
      <div style={{ maxHeight: `${showPlaceholder ? "54px" : ""}` }}>
        <SelectContent
          id={id.current}
          isMobile={mobile}
          isShownDropdown={isShownDropdown}
          onChange={onValueChange}
          onBlur={onSelectBlur}
          onFocus={onSelectFocus}
          value={selectValue}
          selectRef={selectRef}
          placeholder={showPlaceholder ? title : placeholder}
          options={visibleOptions}
          onSearch={handleFilterChange}
          getPopupContainer={getPopupContainer}
        />
      </div>
    );
  };

  const renderContent = (mobile?) => {
    if (options.length < 2) {
      return (
        <CheckboxContent
          options={options}
          value={getValue()}
          onChange={onValueChange}
        />
      );
    }

    return renderSelect(mobile);
  };

  return (
    <React.Fragment>
      {!showPlaceholder && title ? (
        <span className={`control-title ${isRequired ? "required" : ""}`}>
          {title}
          {tooltip && (
              <Tooltip title={tooltip} placement="top">
                <Icon
                    className={styles.infoIcon}
                    type="info-circle-o"
                />
              </Tooltip>
          )}
        </span>
      ) : null}
      {isSearchMobile(getWindowWidth()) && options.length > 1 ? (
        <React.Fragment>
          <MultiSelectModal
            title={title}
            options={options}
            value={getValue()}
            onCancel={closeModal}
            visible={isShowModal}
            onOk={onValueChange}
          />
          <div role="button" tabIndex={-1} onClick={showModal} style={{ position: "relative" }}>
            <div style={{ position: "absolute", inset: 0, zIndex: 1 }}></div>
            {renderContent(true)}
          </div>
        </React.Fragment>
      ) : (
        renderContent()
      )}
    </React.Fragment>
  );
};

MultiSelector.defaultProps = {
  options: [],
  title: "",
  onChange: () => null,
  isRequired: false,
  placeholder: "Odaberite",
  showPlaceholder: false
};

export default MultiSelector;



// WEBPACK FOOTER //
// ./src/components/FormControls/MultiSelector/MultiSelector.tsx